<template>
  <v-row justify="center">
    <v-dialog v-model="openDialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="mx-3 pl-6 pt-4">
          <span class="text-h5">Benutzer bearbeiten</span>
        </v-card-title>
        <v-divider class="mx-9" />
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="ID"
                  readonly
                  disabled
                  v-model="selectedUser.id"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Vorname"
                  required
                  v-model="selectedUser.firstName"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Nachname"
                  required
                  v-model="selectedUser.lastName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Firma"
                  required
                  v-model="selectedUser.company"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Telefon"
                  required
                  v-model="selectedUser.phone"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Adresse"
                  required
                  v-model="selectedUser.address"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Postleitzahl"
                  required
                  v-model="selectedUser.zipCode"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  hide-details
                  label="Stadt"
                  required
                  v-model="selectedUser.city"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="selectedUser.groups"
                  :items="api.userGroups"
                  label="Benutzergruppen zuweisen"
                  item-title="name"
                  item-value="id"
                  hide-selected
                  no-data-text="Keine Benutzergruppen verfügbar"
                  multiple
                  bg-color="accent"
                  clearable
                  chips
                  variant="filled"
                  :return-object="false"
                >
                  <template
                    v-slot:chip="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :model-value="selected"
                      closable
                      variant="flat"
                      color="secondary"
                      @click="select"
                      @click:close="removeUserGroup(item.value)"
                    >
                      <span>{{
                        api.userGroups?.find((r) => r.id === item.value)?.name
                      }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox
                  label="Verifiziert"
                  v-model="selectedUser.isVerified"
                  color="primary"
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  label="Suspendiert"
                  v-model="selectedUser.isSuspended"
                  color="primary"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="mb-5"
            color="primary"
            variant="elevated"
            @click="submitChanges"
            :loading="inProgress"
          >
            Speichern
          </v-btn>
          <v-btn class="mb-5 mr-5" variant="outlined" @click="closeDialog">
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ApiUsersService from "@/services/api/ApiUsersService";
import { mapActions } from "vuex";
import ApiUserGroupService from "../../services/api/ApiUserGroupService";

export default {
  name: "UserEdit",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      api: {
        roles: [],
        userGroups: [],
      },
      inProgress: false,
    };
  },
  computed: {
    openDialog: {
      get() {
        return this.open;
      },
    },
    selectedUser: {
      get() {
        return this.user;
      },
    },
  },
  methods: {
    ...mapActions({
      startLoading: "loading/start",
      stopLoading: "loading/stop",
    }),
    closeDialog() {
      this.$emit("close");
    },
    removeUserGroup(item) {
      this.selectedUser.groups?.splice(
        this.selectedUser.groups?.indexOf(item),
        1
      );
    },
    async submitChanges() {
      try {
        this.inProgress = true;
        await ApiUsersService.submitUser(this.selectedUser);
        this.closeDialog();
      } catch (error) {
        console.error(error);
      } finally {
        this.inProgress = false;
      }
    },
    async fetchUserGroups() {
      await ApiUserGroupService.getInstanceLevelUserGroups().then((result) => {
        this.api.userGroups = result;
      });
    },
  },
  mounted() {
    this.fetchUserGroups();
  },
};
</script>

<style scoped></style>
